import { atom } from "recoil";

const openOptionsAtom = atom({
  key: "openOptionsState",
  default: false,
});

export default openOptionsAtom;
